package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class FinanceAccountQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    name: String,
    type: String,
    currency: String,
    balance: Long,
    icon: String,
    color: String,
    bank: String?,
    last4: String?,
    low_threshold: Long?,
    high_threshold: Long?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_639_743_016, arrayOf("finance_account"), driver, "FinanceAccount.sq",
      "selectAll",
      "SELECT finance_account.id, finance_account.name, finance_account.type, finance_account.currency, finance_account.balance, finance_account.icon, finance_account.color, finance_account.bank, finance_account.last4, finance_account.low_threshold, finance_account.high_threshold, finance_account.order_index, finance_account.created_at, finance_account.updated_at, finance_account.is_deleted, finance_account.deleted_at, finance_account.synced_at FROM finance_account WHERE is_deleted = 0 ORDER BY order_index, name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9),
      cursor.getLong(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)
    )
  }

  public fun selectAll(): Query<Finance_account> = selectAll { id, name, type, currency, balance,
      icon, color, bank, last4, low_threshold, high_threshold, order_index, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Finance_account(
      id,
      name,
      type,
      currency,
      balance,
      icon,
      color,
      bank,
      last4,
      low_threshold,
      high_threshold,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    name: String,
    type: String,
    currency: String,
    balance: Long,
    icon: String,
    color: String,
    bank: String?,
    last4: String?,
    low_threshold: Long?,
    high_threshold: Long?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9),
      cursor.getLong(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)
    )
  }

  public fun selectById(id: String): Query<Finance_account> = selectById(id) { id_, name, type,
      currency, balance, icon, color, bank, last4, low_threshold, high_threshold, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Finance_account(
      id_,
      name,
      type,
      currency,
      balance,
      icon,
      color,
      bank,
      last4,
      low_threshold,
      high_threshold,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    name: String,
    type: String,
    currency: String,
    balance: Long,
    icon: String,
    color: String,
    bank: String?,
    last4: String?,
    low_threshold: Long?,
    high_threshold: Long?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(462_649_929, arrayOf("finance_account"), driver, "FinanceAccount.sq",
      "selectDirty",
      "SELECT finance_account.id, finance_account.name, finance_account.type, finance_account.currency, finance_account.balance, finance_account.icon, finance_account.color, finance_account.bank, finance_account.last4, finance_account.low_threshold, finance_account.high_threshold, finance_account.order_index, finance_account.created_at, finance_account.updated_at, finance_account.is_deleted, finance_account.deleted_at, finance_account.synced_at FROM finance_account WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9),
      cursor.getLong(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)
    )
  }

  public fun selectDirty(): Query<Finance_account> = selectDirty { id, name, type, currency,
      balance, icon, color, bank, last4, low_threshold, high_threshold, order_index, created_at,
      updated_at, is_deleted, deleted_at, synced_at ->
    Finance_account(
      id,
      name,
      type,
      currency,
      balance,
      icon,
      color,
      bank,
      last4,
      low_threshold,
      high_threshold,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    name: String,
    type: String,
    currency: String,
    balance: Long,
    icon: String,
    color: String,
    bank: String?,
    last4: String?,
    low_threshold: Long?,
    high_threshold: Long?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9),
      cursor.getLong(10),
      cursor.getLong(11)!!,
      cursor.getLong(12)!!,
      cursor.getLong(13)!!,
      cursor.getLong(14)!!,
      cursor.getLong(15),
      cursor.getLong(16)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Finance_account> = selectByIdAnyState(id) { id_,
      name, type, currency, balance, icon, color, bank, last4, low_threshold, high_threshold,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Finance_account(
      id_,
      name,
      type,
      currency,
      balance,
      icon,
      color,
      bank,
      last4,
      low_threshold,
      high_threshold,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    name: String,
    type: String,
    currency: String,
    balance: Long,
    icon: String,
    color: String,
    bank: String?,
    last4: String?,
    low_threshold: Long?,
    high_threshold: Long?,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_561_082_682, """
        |INSERT INTO finance_account(id, name, type, currency, balance, icon, color, bank, last4, low_threshold, high_threshold, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 14) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, type)
          bindString(3, currency)
          bindLong(4, balance)
          bindString(5, icon)
          bindString(6, color)
          bindString(7, bank)
          bindString(8, last4)
          bindLong(9, low_threshold)
          bindLong(10, high_threshold)
          bindLong(11, order_index)
          bindLong(12, created_at)
          bindLong(13, updated_at)
        }
    notifyQueries(-1_561_082_682) { emit ->
      emit("finance_account")
    }
  }

  public fun update(
    name: String,
    type: String,
    currency: String,
    icon: String,
    color: String,
    bank: String?,
    last4: String?,
    low_threshold: Long?,
    high_threshold: Long?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_216_136_490, """
        |UPDATE finance_account
        |SET name = ?, type = ?, currency = ?, icon = ?, color = ?, bank = ?, last4 = ?, low_threshold = ?, high_threshold = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 12) {
          bindString(0, name)
          bindString(1, type)
          bindString(2, currency)
          bindString(3, icon)
          bindString(4, color)
          bindString(5, bank)
          bindString(6, last4)
          bindLong(7, low_threshold)
          bindLong(8, high_threshold)
          bindLong(9, order_index)
          bindLong(10, updated_at)
          bindString(11, id)
        }
    notifyQueries(-1_216_136_490) { emit ->
      emit("finance_account")
    }
  }

  public fun updateFromRemote(
    name: String,
    type: String,
    currency: String,
    balance: Long,
    icon: String,
    color: String,
    bank: String?,
    last4: String?,
    low_threshold: Long?,
    high_threshold: Long?,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_403_512_826, """
        |UPDATE finance_account
        |SET name = ?, type = ?, currency = ?, balance = ?, icon = ?, color = ?, bank = ?, last4 = ?, low_threshold = ?, high_threshold = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 13) {
          bindString(0, name)
          bindString(1, type)
          bindString(2, currency)
          bindLong(3, balance)
          bindString(4, icon)
          bindString(5, color)
          bindString(6, bank)
          bindString(7, last4)
          bindLong(8, low_threshold)
          bindLong(9, high_threshold)
          bindLong(10, order_index)
          bindLong(11, updated_at)
          bindString(12, id)
        }
    notifyQueries(-1_403_512_826) { emit ->
      emit("finance_account")
    }
  }

  public fun updateBalance(
    balance: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-2_004_611_290,
        """UPDATE finance_account SET balance = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, balance)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-2_004_611_290) { emit ->
      emit("finance_account")
    }
  }

  public fun adjustBalance(
    balance: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_627_781_728,
        """UPDATE finance_account SET balance = balance + ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, balance)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-1_627_781_728) { emit ->
      emit("finance_account")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_768_509_954,
        """UPDATE finance_account SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_768_509_954) { emit ->
      emit("finance_account")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-2_008_542_687,
        """UPDATE finance_account SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-2_008_542_687) { emit ->
      emit("finance_account")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(1_588_447_747, """DELETE FROM finance_account WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(1_588_447_747) { emit ->
      emit("finance_account")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-1_323_563_724,
        """UPDATE finance_account SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-1_323_563_724) { emit ->
      emit("finance_account")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("finance_account", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("finance_account", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(707_615_355,
        """SELECT finance_account.id, finance_account.name, finance_account.type, finance_account.currency, finance_account.balance, finance_account.icon, finance_account.color, finance_account.bank, finance_account.last4, finance_account.low_threshold, finance_account.high_threshold, finance_account.order_index, finance_account.created_at, finance_account.updated_at, finance_account.is_deleted, finance_account.deleted_at, finance_account.synced_at FROM finance_account WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "FinanceAccount.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("finance_account", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("finance_account", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-412_040_800,
        """SELECT finance_account.id, finance_account.name, finance_account.type, finance_account.currency, finance_account.balance, finance_account.icon, finance_account.color, finance_account.bank, finance_account.last4, finance_account.low_threshold, finance_account.high_threshold, finance_account.order_index, finance_account.created_at, finance_account.updated_at, finance_account.is_deleted, finance_account.deleted_at, finance_account.synced_at FROM finance_account WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "FinanceAccount.sq:selectByIdAnyState"
  }
}
